import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskLevel3.vue?vue&type=template&id=4da04eb9&scoped=true&"
import script from "./BusinessNameDataUpdateTaskLevel3.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskLevel3.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskLevel3.vue?vue&type=style&index=0&id=4da04eb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da04eb9",
  null
  
)

export default component.exports